
// vue
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  nextTick,
  watch,
} from 'vue';

export default defineComponent({
  name: 'CustomInput',
  props: {
    placeholder: {
      type: String,
      required: false,
      defaultValue: '',
    },
    inputVal: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    // textarea
    const textareaRef = ref(null);
    let height = ref('45px');

    // textareaの文字数に応じて高さを更新
    const resize = () => {
      height.value = 'auto';
      nextTick(() => {
        const textareaDOM: HTMLTextAreaElement = textareaRef.value!;
        let scrollHeight = textareaDOM.scrollHeight;
        // 最大の高さはCSSで別途指定
        height.value = scrollHeight + 'px';
      });
    };

    const onInput = (event: { target: HTMLInputElement }) => {
      resize();
      emit('update:inputVal', event.target.value);
    };

    // チャット送信後の発火用
    watch(
      () => props.inputVal,
      () => {
        resize();
      }
    );

    onMounted(() => {
      resize();
    });

    const styles = computed(() => {
      return { height: height.value };
    });

    return {
      textareaRef,
      styles,
      resize,
      onInput,
    };
  },
});
